/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from 'react-router-dom';
import { Field, Form, Formik } from 'formik';
import { Col, Row, Container as GridContainer } from "components/Grid";
import { Label } from "components/Form";
import Layout from "components/Layout/index";
import StepNavigation from "components/StepNavigation";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer } from 'components/Button';
import BrokingSummary from "components/BrokingSummary";
import ClaimsSummary from 'components/ClaimsSummary';
import TextField from 'components/Form/TextField';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import CheckBox from "components/Form/CheckBox";
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import { Title, ButtonContent, PartyContainer } from "./styles";
import RenderButtons from 'components/RenderButtons';
import { useHeaderNbi, useListContactsByType, useWordingHtmlModal } from 'services/QuoteService';
import {
    usePaymentConfigurationForm,
    usePaymentPackHtmlModal,
    useSavePaymentPackContactParties
} from 'services/PaymentPackService'
import HasPermission from 'components/HasPermission/index';
import ContactsGrid from "components/partiesGrid/index";
import PartiesGrid from "components/partiesGrid/index";
import { useGetQuestionnaireAnswer, useSaveQuestionnaireAnswer } from '@fitinsur/services/QuestionnaireAnswerService';
import { PartiesDocumentsSection } from "./sections/index";
import { GeneralSection } from "./sections/general/index";
import { SECTIONS } from "./utils";

export default function SendPaymentPackInsurerClient(props) {
    const [summary, setSummary] = useState({});
    const authContext = useContext(GlobalAuthContext);
    const [selectedItems, setSelectedItems] = useState({ to: [], cc: [] });
    const [selectedItems2, setSelectedItems2] = useState({ to: [], cc: [] });
    const [selectedExternalBrokers, setSelectedExternalBrokers] = useState({ to: [], cc: [] });
    const [selectedThirdParties, setSelectedThirdParties] = useState({ to: [], cc: [] });
    const [insurers, setInsurers] = useState([]);
    const [historymsg, setHistorymsg] = useState([]);
    const [client, setClient] = useState([]);
    const [externalBrokers, setExternalBrokers] = useState([]);
    const [thirdParties, setThirdParties] = useState([]);
    const [endorsmentType, setEndorsmentType] = useState("");
    const [files, setFiles] = useState([]);
    const [hasContactsParties, setHasContactsParties] = useState(false);
    const [newFile, setNewFile] = useState(null);
    const [generatePaymentPack, setGeneratePaymentPack] = useState(null);
    const [sendFiles, setSendFiles] = useState([]);
    const [contactsParties, setContactsParties] = useState({
        client: null,
        insurers: [],
        externalBrokers: [],
        thirdParties: [],
    });
    const [statusEndorsement, setStatusEndorsement] = useState({
        title: "SEND ENDORSEMENT PACK",
        route: "",
    });
    const [isClaims, setIsClaims] = useState(false);
    const [questionnaire, setQuestionnaire] = useState([]);
    const [listContactsCalls, setListContactsCalls] = useState(0);
    const [isEndorsementWithoutPaymentPack, setIsEndorsementWithoutPaymentPack] = useState(false);
    const [isDirectPaymentAnswer, setIsDirectPaymentAnswer] = useState(false);

    const formik = useRef(null);
    const refQuestionnaireSent = useRef(false);
    const history = useHistory();
    const fitinsur = new FitinsurAPI();
    const mc = new MessageCenter();
    const loading = useContext(GlobalLoaderContext);

    const {
        data: useHeaderNbiData,
        loading: useHeaderNbiLoading,
        error: useHeaderNbiError,
        status: useHeaderNbiStatus,
        request: useHeaderNbiRequest,
    } = useHeaderNbi();

    const {
        data: usePaymentConfigurationFormData,
        loading: usePaymentConfigurationFormLoading,
        error: usePaymentConfigurationFormError,
        status: usePaymentConfigurationFormStatus,
        request: usePaymentConfigurationFormRequest,
    } = usePaymentConfigurationForm(props.match.params.idOperation);

    const {
        data: useListContactsByTypeData,
        loading: useListContactsByTypeLoading,
        error: useListContactsByTypeError,
        status: useListContactsByTypeStatus,
        request: useListContactsByTypeRequest,
    } = useListContactsByType('insurer', props.match.params.idOperation);

    const {
        data: useSavePaymentPackContactPartiesData,
        loading: useSavePaymentPackContactPartiesLoading,
        error: useSavePaymentPackContactPartiesError,
        status: useSavePaymentPackContactPartiesStatus,
        request: useSavePaymentPackContactPartiesRequest,
    } = useSavePaymentPackContactParties();

    const {
        data: usePaymentPackHtmlModalData,
        loading: usePaymentPackHtmlModalLoading,
        error: usePaymentPackHtmlModalError,
        status: usePaymentPackHtmlModalStatus,
        request: usePaymentPackHtmlModalRequest,
    } = usePaymentPackHtmlModal(props.match.params.idOperation);

    const {
        data: useGetQuestionnaireAnswerData,
        loading: useGetQuestionnaireAnswerLoading,
        error: useGetQuestionnaireAnswerError,
        status: useGetQuestionnaireAnswerStatus,
        request: useGetQuestionnaireAnswerRequest,
    } = useGetQuestionnaireAnswer(props.match.params.idOperation);

    const {
        data: useSaveQuestionnaireAnswerData,
        loading: useSaveQuestionnaireAnswerLoading,
        error: useSaveQuestionnaireAnswerError,
        status: useSaveQuestionnaireAnswerStatus,
        request: useSaveQuestionnaireAnswerRequest,
    } = useSaveQuestionnaireAnswer(props.match.params.idOperation);

    const {
        data: useWordingHtmlModalData,
        loading: useWordingHtmlModalLoading,
        error: useWordingHtmlModalError,
        status: useWordingHtmlModalStatus,
        request: useWordingHtmlModalRequest,
    } = useWordingHtmlModal(props.match.params.idOperation);

    useEffect(() => {
        if (
            useHeaderNbiLoading ||
            usePaymentConfigurationFormLoading ||
            useListContactsByTypeLoading ||
            usePaymentPackHtmlModalLoading ||
            useGetQuestionnaireAnswerLoading ||
            useSavePaymentPackContactPartiesLoading ||
            useSaveQuestionnaireAnswerLoading ||
            useWordingHtmlModalLoading
        ) {
            loading.start();
        } else {
            loading.stop();
        }
    }, [
        useHeaderNbiLoading,
        usePaymentConfigurationFormLoading,
        useListContactsByTypeLoading,
        usePaymentPackHtmlModalLoading,
        useGetQuestionnaireAnswerLoading,
        useSavePaymentPackContactPartiesLoading,
        useSaveQuestionnaireAnswerLoading,
        useWordingHtmlModalLoading
    ]);

    const validation = () => {
        if (selectedItems.to.length <= 0 || selectedItems2.to.length <= 0) {
            return false;
        } else {
            return true;
        }
    }

    const goToLoginPage = () => {
        history.push('/login');
    };

    async function handleSummary() {
        return useHeaderNbiRequest({ idOperation: props.match.params.idOperation }, null).then(({ data }) => {
            setSummary({
                typeOfCover: data.ret_value.typeOfCover,
                client: data.ret_value.client,
                obligorCoding: data.ret_value.obligorCoding,
                responseBy: data.ret_value.responseBy,
                internalContact: data.ret_value.internalContact,
                broker: data.ret_value.broker,
                dealCode: data.ret_value.deal,
                nmFacility: data.ret_value.nmFacility,
                nmObligor: data.ret_value.nmObligor,
                projectName: data.ret_value.projectName,
                idOperation: props.match.params.idOperation,
            });
            setHistorymsg(data.ret_value.historical);
            setEndorsmentType(data.ret_value.endorsmentType);
            handlePaymentPackInfos(data.ret_value.endorsmentType);
        })
            .catch((error) => {
                mc.error("Erro executando consulta\n" + error);
                console.error('fitPostSummary - Error:', error);
            });
    };

    function handlePaymentPackInfos(endorsmentType) {
        const generatePaymentPack = !endorsmentType || ['not-pre-agreed', 'cancellation', 'pre-agreed', 'market-changes', 'declaration'].includes(endorsmentType)
        setGeneratePaymentPack(generatePaymentPack)
        if (!generatePaymentPack) {
            useWordingHtmlModalRequest(null, { renderWelcomekit: 1 }).then(({ data: resp }) => {
                if (resp.ret_code === 200) {
                    const { paymentPackDocs, contactsParties } = resp.ret_value;
                    console.log("resp.ret_value.policePackReturnDocs", resp.ret_value.policePackReturnDocs)
                    setFiles(resp.ret_value.policePackReturnDocs
                        .map(document => ({
                            idDocument: document.idDocument,
                            idDomainDescription: document.idDomainDescription,
                            idReport: document.idReport,
                            idOperation: document.idOperation,
                            reportToken: document.reportToken,
                            url: document.url,
                            fileName: document.documentMetadata.fileName,
                            title: document.documentMetadata.fileName,
                        })));

                    if (contactsParties) {
                        setContactsParties(contactsParties);
                    }
                    useGetQuestionnaireAnswerRequest();
                } else {
                    mc.error(resp.ret_msg_details);
                }
            }).catch((error) => {
                mc.error(`There was an error while fetching your data: ${handlePaymentPackInfos.name}\n` + error);
            });
        } else {
            usePaymentPackHtmlModalRequest().then(({ data: resp }) => {
                if (resp.ret_code === 200) {
                    const { paymentPackDocs, contactsParties } = resp.ret_value;
                    setFiles(resp.ret_value.paymentPackDocs);

                    if (contactsParties) {
                        setContactsParties(contactsParties);
                    }
                    useGetQuestionnaireAnswerRequest();
                } else {
                    mc.error(resp.ret_msg_details);
                }
            }).catch((error) => {
                mc.error(`There was an error while fetching your data: ${handlePaymentPackInfos.name}\n` + error);
            });
        }
    };

    const createContacts = (party, sendFiles) => {
        return party.map(x => {
            const partyFiles = sendFiles.find(file => file.idPerson === x.idPersonInsurer);
            const idDocuments = partyFiles ? partyFiles.files.map(file => file?.idDocument) : [];
            return {
                idPersonInsurer: x.idPersonInsurer,
                insurerFirstName: x.insurerFirstName,
                contactsTo: [],
                contactsCC: [],
                idDocuments,
            };
        });
    };

    const addSelectedContacts = (contactsList, selectedItems) => {
        selectedItems.to.forEach(selected => {
            const contact = contactsList.find(c => c.idPersonInsurer === selected.idPersonInsurer);
            if (contact) contact.contactsTo.push({
                idContact: selected.idContact,
                email: selected.email,
                idPersonInsurer: selected.idPersonInsurer,
                nameContact: selected.nameContact
            });
        });
        selectedItems.cc.forEach(selected => {
            const contact = contactsList.find(c => c.idPersonInsurer === selected.idPersonInsurer);
            if (contact) contact.contactsCC.push({
                idContact: selected.idContact,
                email: selected.email,
                idPersonInsurer: selected.idPersonInsurer,
                nameContact: selected.nameContact
            });
        });
    };

    function handleAttachments(questionnaire) {
        if (!generatePaymentPack) {
            return handleSend();
        }

        let attachments = [];
        try {
            const attachmentQst = questionnaire.find(question => question.idQuestion === 2143);
            attachments = Array.isArray(attachmentQst.answer) ? attachmentQst.answer : JSON.parse(attachmentQst.answer).length
        } catch (error) {
        }

        if (!attachments.length) return handleSend();

        fitinsur.setAuthToken(authContext.token);
        return fitinsur.requestPostAttachmentsPaymentPack(props.match.params.idOperation, attachments)
            .then(resp => resp.json())
            .then(data => {
                if (data.ret_code !== 200) {
                    loading.stop();
                    mc.error(data.ret_msg_details);
                    return;
                }

                handleSend()
                loading.stop();
            }).catch((error) => {
                mc.error(`There was an error while fetching your data: ${handleAttachments.name}\n` + error);
            });
    }

    function handleSend() {
        fitinsur.setAuthToken(authContext.token);

        // Criando lista de contatos com ids de documentos selecionados
        const insuresContacts = createContacts(insurers, sendFiles);
        const clientContacts = createContacts(client, sendFiles);
        const externalBrokersContacts = createContacts(externalBrokers, sendFiles);
        const thirdPartyContacts = createContacts(thirdParties, sendFiles);

        // Adicionando contatos selecionados
        addSelectedContacts(insuresContacts, selectedItems);
        addSelectedContacts(clientContacts, selectedItems2);
        addSelectedContacts(externalBrokersContacts, selectedExternalBrokers);
        addSelectedContacts(thirdPartyContacts, selectedThirdParties);

        const contactsParties = {
            client: clientContacts[0],
            insurers: insuresContacts,
            externalBrokers: externalBrokersContacts,
            thirdParties: thirdPartyContacts,
        };

        const body = {
            idOperation: props.match.params.idOperation,
            contactsParties,
        };

        useSavePaymentPackContactPartiesRequest(body)
            .then(({ data }) => {
                if (data.ret_code !== 200) {
                    mc.error(data.ret_msg_details);
                    return;
                }

                history.push('/broking/payment-pack-distribution-summary/' + props.match.params.idOperation, { isDirectPaymentAnswer });
            })
            .catch(error => {
                mc.error("Erro executando consulta\n" + error);
                console.error("fitPostReject - Error:", error);
            });

        // Código comentado para envio (descomentar se necessário)
        /*
        useSendPaymantPackToInsurerAndClientRequest({...body}).then(({data}) => {
          if (data.ret_code !== 200) {
            mc.error(data.ret_msg_details);
            return;
          }
          return isClaims ? history.push('/claims') : history.push('/policies');
        })
        .catch((error) => {
          mc.error("Erro executando consulta\n" + error);
          console.error('fitPostReject - Error:', error);
        });
        */
    }

    function handleSelectContact(e, insurer = null, cc = false, type) {
        const contact = {
            idPersonInsurer: insurer.idPersonInsurer,
            idContact: e.idContact,
            email: e.email,
            nameContact: e.nameContact
        };
        let selectedGroup;
        let setSelectedGroup;

        switch (type) {
            case 'insurer':
                selectedGroup = selectedItems;
                setSelectedGroup = setSelectedItems;
                break;
            case 'external-broker':
                selectedGroup = selectedExternalBrokers;
                setSelectedGroup = setSelectedExternalBrokers;
                break;
            case 'client':
                selectedGroup = selectedItems2;
                setSelectedGroup = setSelectedItems2;
                break;
            case 'third-party':
                selectedGroup = selectedThirdParties;
                setSelectedGroup = setSelectedThirdParties;
                break;
            default:
                return;
        }

        const key = cc ? 'cc' : 'to';
        const alreadySelectedIndex = selectedGroup[key].findIndex(item => item.idContact === contact.idContact);

        if (alreadySelectedIndex >= 0) {
            const filteredItems = selectedGroup[key].filter(item => item.idContact !== contact.idContact);
            setSelectedGroup({ ...selectedGroup, [key]: filteredItems });
        } else {
            const newList = [...selectedGroup[key], contact];
            setSelectedGroup({ ...selectedGroup, [key]: newList });
        }
    }

    function listContacts(idContactDepartment) {
        useListContactsByTypeRequest(null, { idContactDepartment: idContactDepartment }, null, `/quote/insurer/list-contacts/${props.match.params.idOperation}?`).then(({ data }) => {
            if (data.ret_code != 200) {
                mc.error(data.ret_msg_details);
                history.goBack();
                return;
            }

            const insurers = data.ret_value?.sort((a, b) => String(a?.nmInsurer).localeCompare(String(b?.nmInsurer))).filter(insurer => isDirectPaymentAnswer || (!insurer.isLloyds && !insurer.isLirma)) || [];
            setInsurers(insurers);
            setListContactsCalls((prevState) => prevState += 1);
        })
            .catch((error) => {
                mc.error("There was an error processing your request. Please try again later");
                console.error('fitPostListContact - Error:', error);
            });
    };

    function listContactsClients(idContactDepartment) {
        useListContactsByTypeRequest(null, { idContactDepartment: idContactDepartment }, null, `/quote/client/list-contacts/${props.match.params.idOperation}?`).then(({ data }) => {
            if (data.ret_code != 200) {
                mc.error(data.ret_msg_details);
                history.goBack();
                return;
            }
            setClient([data.ret_value_clients]);
            setListContactsCalls((prevState) => prevState += 1);
        })
            .catch((error) => {
                mc.error("There was an error processing your request. Please try again later");
                console.error('fitPostListContact - Error:', error);
            });
    };


    function listExternalContacts(idContactDepartment) {
        useListContactsByTypeRequest(null, { idContactDepartment: idContactDepartment }, null, `/quote/external/list-contacts/${props.match.params.idOperation}?`).then(({ data }) => {
            if (data.ret_code != 200) {
                mc.error(data.ret_msg_details);
                history.goBack();
                return;
            }
            setExternalBrokers(data.ret_value);
            setListContactsCalls((prevState) => prevState += 1);
        })
            .catch((error) => {
                mc.error("There was an error processing your request. Please try again later");
                console.error('fitPostListContact - Error:', error);
            });
    };

    function listThirdPartiesContacts(idContactDepartment) {
        useListContactsByTypeRequest(null, { idContactDepartment: idContactDepartment }, null, `/quote/third-party/list-contacts/${props.match.params.idOperation}?`).then(({ data }) => {
            if (data.ret_code != 200) {
                mc.error(data.ret_msg_details);
                history.goBack();
                return;
            }
            setThirdParties(data.ret_value);
            setListContactsCalls((prevState) => prevState += 1);
        })
            .catch((error) => {
                mc.error("There was an error processing your request. Please try again later");
                console.error('fitPostListContact - Error:', error);
            });
    };

    function getPaymentConfigurationForm() {
        usePaymentConfigurationFormRequest().then(({ data: response }) => {
            if (response.ret_code != 200) {
                mc.error(response.ret_msg_details);
                history.goBack();
                return;
            }
            setIsClaims(response.ret_value.isClaims);
        }).catch((error) => {
            mc.error(`There was an error while fetching your data: ${getPaymentConfigurationForm.name}\n` + error);
        });
    }

    const updatePartyFiles = (idPersonInsurer, idDocuments, updatedFiles) => {
        const partyFiles = idDocuments.map((idDocument) => updatedFiles.find(file => file?.idDocument === idDocument));
        setSendFiles((prevSendFiles) => {
            return prevSendFiles.map((party) => {
                return party.idPerson === idPersonInsurer
                    ? { ...party, files: partyFiles }
                    : party;
            });
        });
    };

    const setSelectedContacts = (party, setParty, contactsTo, contactsCC, setSelectedContacts, selectedContacts) => {
        const extractIds = (items) => items.map(item => typeof item !== 'number' ? item.idContact : item);
        const toIds = extractIds(contactsTo);
        const ccIds = extractIds(contactsCC);

        let toContacts = party?.contacts?.filter(contact => toIds.includes(contact.idContact)) || [];

        toContacts = toContacts.map((contact) => ({
            idPersonInsurer: party.idPersonInsurer,
            idContact: contact.idContact,
            email: contact.email,
            nameContact: contact.nameContact
        }))

        let ccContacts = party?.contacts?.filter(contact => ccIds.includes(contact.idContact)) || [];

        ccContacts = ccContacts.map((contact) => ({
            idPersonInsurer: party.idPersonInsurer,
            idContact: contact.idContact,
            email: contact.email,
            nameContact: contact.nameContact
        }))

        setSelectedContacts((prevState) => ({
            ...prevState,
            to: [...prevState.to, ...toContacts],
            cc: [...prevState.cc, ...ccContacts]
        }))

        setParty((prevState) => prevState.map((item) => {
            if (item.idPersonInsurer === party.idPersonInsurer) {
                const allContacts = item.contacts.map((contact) => {
                    if (toIds.includes(contact.idContact) || ccIds.includes(contact.idContact)) {
                        contact.tempContact = true;
                    }
                    return contact
                });
                return {
                    ...item,
                    contacts: allContacts
                };
            }
            return item;
        }))
    };

    const existingInsurer = (insurer) => {
        return insurers.find((item) => item.idPersonInsurer === insurer.idPersonInsurer);
    }

    const handleContactsParties = (updatedFiles) => {
        const {
            client: partyClient,
            insurers: partyInsurers,
            externalBrokers: partyExternalBrokers,
            thirdParties: partyThirdParties
        } = contactsParties;

        if (partyClient) {
            const currentParty = client.find(tp => tp.idPersonInsurer === partyClient.idPersonInsurer);
            setSelectedContacts(currentParty, setClient, partyClient.contactsTo, partyClient.contactsCC, setSelectedItems2, selectedItems);
            if (partyClient.idDocuments.length) {
                updatePartyFiles(partyClient.idPersonInsurer, partyClient.idDocuments, updatedFiles);
            }
        }

        partyInsurers.forEach((insurer) => {
            if (existingInsurer(insurer)) {
                const currentParty = insurers.find(tp => tp.idPersonInsurer === insurer.idPersonInsurer);
                setSelectedContacts(currentParty, setInsurers, insurer.contactsTo, insurer.contactsCC, setSelectedItems, selectedItems2);
                if (insurer.idDocuments.length) {
                    updatePartyFiles(insurer.idPersonInsurer, insurer.idDocuments, updatedFiles);
                }
            }
        });

        if (partyExternalBrokers) {
            partyExternalBrokers.forEach((externalBroker) => {
                const currentParty = externalBrokers.find(tp => tp.idPersonInsurer === externalBroker.idPersonInsurer);
                setSelectedContacts(currentParty, setExternalBrokers, externalBroker.contactsTo, externalBroker.contactsCC, setSelectedExternalBrokers, selectedExternalBrokers);
                if (externalBroker.idDocuments.length) {
                    updatePartyFiles(externalBroker.idPersonInsurer, externalBroker.idDocuments, updatedFiles);
                }
            });
        }

        if (partyThirdParties) {
            partyThirdParties.forEach((thirdParty) => {
                const currentParty = thirdParties.find(tp => tp.idPersonInsurer === thirdParty.idPersonInsurer);
                setSelectedContacts(currentParty, setThirdParties, thirdParty.contactsTo, thirdParty.contactsCC, setSelectedThirdParties, selectedThirdParties);
                if (thirdParty.idDocuments.length) {
                    updatePartyFiles(thirdParty.idPersonInsurer, thirdParty.idDocuments, updatedFiles);
                }
            });
        }
    };

    useEffect(() => {
        if (useGetQuestionnaireAnswerStatus === 200) {
            handleQuestionnaire(useGetQuestionnaireAnswerData.value);
        }
    }, [useGetQuestionnaireAnswerStatus])

    useEffect(() => {
        fitinsur.setAuthToken(authContext.token);

        handleSummary().then(() => {
            listContacts();
            listContactsClients();
            listExternalContacts();
            listThirdPartiesContacts();
            getPaymentConfigurationForm();
        });
    }, [])

    useEffect(() => {
        if (listContactsCalls > 3) {
            if (contactsParties.client) {
                setHasContactsParties(true);
            }
        }
    }, [listContactsCalls])

    useEffect(() => {
        if (useSaveQuestionnaireAnswerStatus === 200) {
            handleAttachments(questionnaire);
            refQuestionnaireSent.current = false;

            useGetQuestionnaireAnswerRequest();
        }
    }, [useSaveQuestionnaireAnswerStatus])

    useEffect(() => {
        setIsEndorsementWithoutPaymentPack(['off-risk', 'policy-extension', 'adjustments-and-corrections', 'client-change'].includes(endorsmentType))

        if (endorsmentType === 'pre-agreed') {
            setStatusEndorsement({
                title: "ANNIVERSARY: PREMIUM PRE AGREED / SEND PAYMENT PACK",
                route: ''
            })
        } else if (endorsmentType === 'not-pre-agreed') {
            setStatusEndorsement({
                title: "ANNIVERSARY: PREMIUM NOT PRE AGREED / SEND PAYMENT PACK",
                route: ''
            })
        } else if (endorsmentType === 'off-risk') {
            return;
        } else if (endorsmentType === 'cancellation') {
            setStatusEndorsement({
                title: "ENDORSEMENT - CANCELLATION / SEND PAYMENT PACK",
                route: ''
            })
        } else if (endorsmentType === 'market-changes') {
            setStatusEndorsement({
                title: "RISK & MARKET CHANGES / SEND PAYMENT PACK",
                route: ''
            })
        } else {
            setStatusEndorsement({
                title: "SEND PAYMENT PACK",
                route: ''
            })
        }
    }, [endorsmentType])

    function handleQuestionnaire(data) {
        let questionnaire = [
            ...data.payments,
        ]

        const { questionnaireAnswers, attachments } = PartiesDocumentsSection.events.handleInitialAdjustments({
            questionnaire,
            externalBrokers,
            thirdParties,
            setFiles,
            setNewFile
        });

        const paymentMethodQuestion = data.paymentConfiguration.find(questionnaire => questionnaire.idQuestion === 140)?.idAnswerOption;
        setIsDirectPaymentAnswer(paymentMethodQuestion === 1027);
        setQuestionnaire(questionnaireAnswers);
        handleContactsParties([...files, ...attachments]);
    }

    function handlePaymentConfiguration() {
        history.push(`/broking/payment-pack-configuration/${props.match.params.idOperation}`)
    };

    return (
        <Layout
            idOperation={props.match?.params?.idOperation}
            title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
            subtitle={summary.dealCode ? summary.dealCode : "Broking code"}
        >
            {isClaims ? <ClaimsSummary stage={3} idOperation={props.match?.params?.idOperation} />
                : <>
                    <StepNavigation stage={3} idOperation={props.match?.params?.idOperation} />
                    <BrokingSummary data={summary} />
                </>}

            <ContentCard
                title={statusEndorsement.title}
                icon
                filterContact
                handleFilterContact={(idContactDepartment) => {
                    listContacts(idContactDepartment);
                    listContactsClients(idContactDepartment);
                    listExternalContacts(idContactDepartment);
                    listThirdPartiesContacts(idContactDepartment);
                }}

                info={{
                    idOperation: props.match?.params?.idOperation || null,
                    idProduct: props.location?.state?.idProduct || null
                }}>
                <Formik
                    innerRef={formik}
                    initialValues={{}}
                >
                    {formikProps => (
                        <Form>
                            <HasPermission permission={!isEndorsementWithoutPaymentPack}>
                                <PartiesDocumentsSection.components.RenderSection
                                    formikProps={formikProps}
                                    formikRef={formik}
                                    idProduct={null}
                                    idOperation={props.match?.params?.idOperation || null}
                                    globalQuestionnaire={questionnaire}
                                    questionnaire={questionnaire}
                                    setQuestionnaire={setQuestionnaire}
                                    files={files}
                                    setFiles={setFiles}
                                    setNewFile={setNewFile}
                                    sendFiles={sendFiles}
                                    setSendFiles={setSendFiles}
                                    setHasContactsParties={setHasContactsParties}
                                />
                            </HasPermission>

                            <HasPermission permission={!isDirectPaymentAnswer && files.length && client.length > 0}>
                                <PartiesGrid
                                    parties={client}
                                    type="client"
                                    handleSelect={handleSelectContact}
                                    selectedItems={selectedItems2}
                                    files={files}
                                    sendFiles={sendFiles}
                                    setSendFiles={setSendFiles}
                                    newFile={newFile}
                                    setNewFile={setNewFile}
                                    setParties={setClient}
                                    hasContactsParties={hasContactsParties}
                                />
                            </HasPermission>

                            <HasPermission
                                permission={(isDirectPaymentAnswer || !isEndorsementWithoutPaymentPack) && files.length && insurers.length > 0}>
                                <PartiesGrid
                                    parties={insurers}
                                    type="insurer"
                                    handleSelect={handleSelectContact}
                                    selectedItems={selectedItems}
                                    files={files}
                                    sendFiles={sendFiles}
                                    setSendFiles={setSendFiles}
                                    newFile={newFile}
                                    setNewFile={setNewFile}
                                    setParties={setInsurers}
                                    hasContactsParties={hasContactsParties}
                                />
                            </HasPermission>

                            <HasPermission
                                permission={!isDirectPaymentAnswer && !isEndorsementWithoutPaymentPack && files.length && externalBrokers.length > 0}>
                                <PartiesGrid
                                    parties={externalBrokers}
                                    type="external-broker"
                                    handleSelect={handleSelectContact}
                                    selectedItems={selectedExternalBrokers}
                                    files={files}
                                    sendFiles={sendFiles}
                                    setSendFiles={setSendFiles}
                                    newFile={newFile}
                                    setNewFile={setNewFile}
                                    setParties={setExternalBrokers}
                                    hasContactsParties={hasContactsParties}
                                />
                            </HasPermission>

                            <HasPermission
                                permission={!isDirectPaymentAnswer && !isEndorsementWithoutPaymentPack && files.length && thirdParties.length > 0}>
                                <PartiesGrid
                                    parties={thirdParties}
                                    type="third-party"
                                    handleSelect={handleSelectContact}
                                    selectedItems={selectedThirdParties}
                                    files={files}
                                    sendFiles={sendFiles}
                                    setSendFiles={setSendFiles}
                                    newFile={newFile}
                                    setNewFile={setNewFile}
                                    setParties={setThirdParties}
                                    hasContactsParties={hasContactsParties}
                                />
                            </HasPermission>

                            <ButtonContainer>
                                <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                                <RenderButtons idOperation={props.match?.params?.idOperation}>
                                    <ButtonContent>
                                        <>
                                            {!isEndorsementWithoutPaymentPack && (
                                                <Button
                                                    style={{ marginLeft: "30px", marginTop: "5px" }}
                                                    third
                                                    id="btnRegeneratePaymentPack"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        handlePaymentConfiguration()
                                                    }}>
                                                    Payment config
                                                </Button>
                                            )}
                                            <Button
                                                style={{ marginLeft: "30px", marginTop: "5px" }}
                                                primary
                                                id="btnSubmit"
                                                onClick={(e) => GeneralSection.events.handleSave({
                                                    values: formikProps.values,
                                                    questionnaire,
                                                    idOperation: props.match?.params?.idOperation,
                                                    SECTIONS,
                                                    isDraft: false,
                                                    mc,
                                                    formikRef: formik,
                                                    refQuestionnaireSent,
                                                    useSaveQuestionnaireAnswerRequest,
                                                    clientsContacts: selectedItems2,
                                                    insurersContacts: selectedItems,
                                                    insurers,
                                                    isEndorsementWithoutPaymentPack,
                                                    isDirectPaymentAnswer,
                                                })
                                                }
                                            >
                                                CONTINUE
                                            </Button>
                                        </>
                                    </ButtonContent>
                                </RenderButtons>
                            </ButtonContainer>
                        </Form>
                    )}
                </Formik>
            </ContentCard>
            {loading.active && (<Loader backdropColor={Colors.WHITE} fullScreen />)}
        </Layout>
    );
}
